import React from 'react';
import Form, { Actions, AddressValidator, PhoneNumber, PhoneNumberValidator } from '../../../Components/Form';
import { GuestAddress } from '../../../Components/Form/Fields/Address';
import { useOnboarding } from '../OnboardingProvider';
import StepShell, { nextSubmit } from '../Components/StepShell';

const ContactDetailsStep = () => {
    const {draft, updateStepData, markSkipped, next, back} = useOnboarding();

    const skip = () => {
        markSkipped('contact');
        next();
    };

    const submit = (data) => {
        updateStepData('contact', {...data, skipped: false});
        next();
    };

    return <StepShell
        title="How can customers reach you?"
        intro={<>
            <p className="mt-2">We ask for your business address because it's legally required on invoices, and it helps with route planning.</p>
        </>}
    >
        <Form
            data={draft.data.contact}
            onChange={(data) => updateStepData('contact', data)}
            onSubmit={submit}
        >
            <PhoneNumber label="Business phone number" name="phoneNumber" validators={[PhoneNumberValidator]} />
            <GuestAddress label="Business address" name="address" validators={[AddressValidator]} />

            <Actions
                submit={nextSubmit}
                cancel={{label: 'Back', onClick: back}}
                left={<button type="button" className="my-3 text-sm text-muted hover:text-brand cursor-pointer" onClick={skip}>
                    I'll do this later
                </button>}
            />
        </Form>
    </StepShell>;
};

export default ContactDetailsStep;
